<div class="overlay-dialog" *ngIf="showDialogLoader()">
    <mat-spinner color="primary" diameter="50"></mat-spinner>
</div>

<div class="overlay" *ngIf="showGlobalLoader()">
    <mat-spinner color="primary" diameter="50"></mat-spinner>
</div>